<template>
  <v-row>
    <v-col cols="12">
      <text-field-like
          v-if="readonly"
          v-model="controllerView.name"
          label="コントローラ名">
      </text-field-like>
      <v-text-field
          v-else
          v-model="controllerView.name"
          label="コントローラ名"
          :rules="[v => !!v || 'コントローラ名が必要です']"
          @change="handleChange"
          autofocus>
      </v-text-field>
    </v-col>
    <v-col cols="12">
      <text-field-like
          v-if="readonly"
          v-model="controllerView.description"
          label="説明"
          placeholder="未設定"
          multi-line>
      </text-field-like>
      <v-textarea
          v-else
          v-model="controllerView.description"
          label="説明"
          @change="handleChange"
          messages="複数行入力可"
          rows="1"
          auto-grow>
      </v-textarea>
    </v-col>
    <v-col cols="12">
      <text-field-like
          v-if="readonly"
          :value="controllerView.pollingRate ? `${controllerView.pollingRate} 秒` : null"
          label="ポーリンク周期"
          placeholder="未設定">
      </text-field-like>
      <v-text-field
          v-else
          v-model="controllerView.pollingRate"
          label="ポーリンク周期 (秒)"
          :rules="[
            v => !!v || 'ポーリング周期が必要です',
            v => v <= 1000 || 'ポーリング周期は1000以下の値にしてください。',
            v => v >= 10 || 'ポーリング周期は10以上の値にしてください。'
          ]"
          @change="handleChange">
      </v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
export default {
  name: 'ControllerForm',
  components: {TextFieldLike},
  model: {
    prop: 'controller',
    event: 'change-form'
  },
  props: {
    controller: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      controllerView: {}
    }
  },
  methods: {
    handleChange() {
      this.$emit('change-form', {...this.controllerView});
    }
  },
  watch: {
    controller: {
      immediate: true,
      handler(value) {
        this.controllerView = {...value};
      }
    },
  }
}
</script>
